module.exports = __webpack_public_path__ + "static/img/role.fd24a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/kr/role.png
// module id = k6oV
// module chunks = 7